import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  return {
    container: {
      paddingTop: '30px',
      width: '100%',
      height: '100%'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      '&.flex-j-e': {
        justifyContent: 'end',
      },
    },
    title: {
      flexGrow: 1,
    },
    section: {
      marginBottom: '32px',
    },
    add: {
      fontSize: '2.4rem',
      color: colors.color4,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    addService: {
      fontSize: '2.4rem',
      color: colors.color4,
      borderRadius: '0px',
      padding: '6px',
      marginTop: '20px',
      '& .MuiSvgIcon-root': {
        fontSize: '0.5em',
      },
    },
    titleContainer: {
      padding: 2,
      backgroundColor: colors.color9,
      color: 'white',
      fontWeight: 'bold'
    },
    customPaper: {
      padding: 3,
      margin: '0px 1px 20px',
      maxHeight: '950px',
      minHeight: '500px',
      '& .pd-3': {
        padding: 3
      }
    },
    subContainer: {
      marginTop: '20px',
      position: 'relative',
      paddingRight: '45px',
      '& .downloadFiles': {
        marginBottom: '5px',
      },
      '& .crud-filter-container.crud-filter-container': { paddingTop: '15px' },
      '& .filterContainer-main': { position: 'relative', bottom: '-10px', marginBottom: 0 },
    },
    containerSaveButton: {
      marginTop: '20px',
      display: 'flex',
      justifyContent: 'end'
    },
    containerChildren: (flag: boolean) => ({
      maxHeight: '800px',
      minHeight: flag ? '294px' : '350px',
      overflow: 'auto',
      scrollbarWidth: 'none',
    }),
    crudModal: {
      height: '280px'
    },
    clean: {
      fontSize: '2.4rem',
      color: colors.color4,
      padding: '6px',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    hide: {
      visibility: 'hidden',
    },
    headerInput: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      width: '400px'
    },
    icon: {
      '& .MuiSvgIcon-root':{
          width: '3em',
          height: '3em',
          color: colors.color8
      }
  },
  }
}

export { useStyles }